/**
 * Extend Marb namespace
 */

try {
	Marb.extend({
		Registration : {
			initCustomerForm : function(formId) {
				$.validator.messages.required = "";
				$.validator.messages.email = "";
				$.validator.messages.equalTo = "";
				$("#"+formId).validate({
					rules : {
						username : {
							required: true,
							email: true,
							remote: {
								url: "/email-check",
								type: "get"
							}
						},
						firstname : {
							required: true
						},
						lastname : {
							required: true
						},
						password : {
							required: true,
							minlength: 4
						},
						passwordConfirm : {
							required: true,
							equalTo: password
						}
					},
					messages: {
						username: {
							remote: $("#validation-email-alreadyExists").data("value")
						},
						password: {
							minlength: $.i18n.prop('p.createuser.msg.fields.password')
						},
						passwordConfirm: {
							equalTo: $.i18n.prop('p.createuser.msg.fields.passwordMatch')
						}
					},
					errorPlacement: function(error,element){
						error.addClass("custom-error");
						error.insertAfter( element.next() );
					},
					errorElement: "div"
				
				});
			}
		}
	})
}
catch (e) {
	debug.error("Marb namespace not present", e);
}
